import '@fontsource/ibm-plex-sans/latin-400.css'
import '@fontsource/ibm-plex-sans/latin-500.css'
import '@fontsource/ibm-plex-sans/latin-600.css'
import '@fontsource/ibm-plex-sans/latin-700.css'
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/inter/latin-700.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App.js'
import { loadConfig } from './config.js'
import { applyTheme, useThemeStore } from './state/theme-store.js'
import './styles/global.css'

// Runtime configuration (config.ts), loaded before the app renders. The app uses
// same-origin API URLs, so the file has no environment-specific values yet.
await loadConfig()

// index.html already applies this before first paint; repeating it here keeps the
// attributes correct for any host page that does not run that inline script.
applyTheme(useThemeStore.getState())

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root element')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
